import { FullLogoSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const EmptyData = ({ children, className }: any) => {
  return (
    <S.Wrapper className={className}>
      <FullLogoSvg colorLetters="#00995D" colorX="#00995D" />
      <h2>{children}</h2>
    </S.Wrapper>
  )
}

export default EmptyData
